import axios from 'axios'

const BASE_HOST_URI = window.env && window.env.baseHost

const request = axios.create({
  baseURL: `${BASE_HOST_URI}`
})

export default request
